import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { event } from "dashboard-utils/lib/utils/clevertap";
import { Typography, PayuIcon, Tabs } from "Components/shared/oneui";
import { nodes } from "Constants/filters";
import DowntimeTable from "./DowntimeTable";
import ActiveDowntime from "./ActiveDowntime";
import {
  downTimeFilterActions,
  downTimeFilterSelectors,
  downTimeListActions,
  downTimeListSelectors,
} from "Store/ducks/downtime";
import { filterActions, filterSelectors } from "Store/ducks";
import { getActiveDowntime } from "Constants/downtime";

const Container = (props) => {
  const {
    fetchDowntime,
    downtimeList,
    downtimeListFetching,
    downtimeListError,
    filters,
    updateFilter,
    fetchDowntimeFilter,
    downtimeFilter,
    downtimeFilterError,
    isdowntimeFilterFetching,
  } = props;
  const [show, setShow] = useState(false);
  useEffect(() => {
    function downtimeNotificationHandler() {
      setShow((s) => !s);
    }
    // Listen for the event.
    window.addEventListener(
      "downtimeNotification",
      downtimeNotificationHandler
    );
    return () =>
      window.removeEventListener(
        "downtimeNotification",
        downtimeNotificationHandler
      );
  }, []);
  
  const handleTabChange = ({ id }) => {
    event("Dashboard CTA clicked", {
      "Event name": "Dashboard CTA clicked",
      "CTA page": ``,
      "CTA name": id === 1 ? "Active Downtime" : "Past Downtime",
      "Section name": "Downtime Notification",
      "CTA type": "Click",
    });
  };

  const TabsData = [
    {
      id: 1,
      title: "Active Downtime",
      content: (
        <ActiveDowntime
          downtimeListFetching={downtimeListFetching}
          downtimeList={getActiveDowntime(downtimeList?.data)}
          downtimeListError={downtimeListError}
          updateFilter={updateFilter}
          show={show}
        />
      ),
    },
    {
      id: 2,
      title: "Past Downtime",
      content: (
        <DowntimeTable
          fetchDowntime={fetchDowntime}
          downtimeListFetching={downtimeListFetching}
          downtimeList={downtimeList}
          downtimeListError={downtimeListError}
          filters={filters}
          updateFilter={updateFilter}
          fetchDowntimeFilter={fetchDowntimeFilter}
          downtimeFilter={downtimeFilter}
          downtimeFilterError={downtimeFilterError}
          isdowntimeFilterFetching={isdowntimeFilterFetching}
        />
      ),
    },
  ];
  return (
    <div className="tw-preflight downtime_container">
      <div
        className={`twside-hidden t:twside-block twside-transition-all twside-duration-10 twside-fixed twside-w-[100vw] twside-h-[100vh] twside-top-[76px] twside-left-[250px] twside-bg-[#00000080] twside-z-[9999] ${
          show ? "twside-visible" : "twside-invisible"
        }`}
      ></div>
      <div
        className={` twside-transition-all twside-duration-500 twside-fixed twside-overflow-auto t:twside-top-[77px] twside-w-full t:twside-w-700 twside-h-[calc(100vh-50px)] t:twside-h-[calc(100vh-76px)] twside-z-[9999] twside-bg-white ${
          show
            ? "t:twside-right-0 twside-top-[50px]"
            : "t:twside-right-[-2000px] twside-top-1000"
        }`}
      >
        <div className="twside-flex twside-justify-between twside-bg-primary-900 twside-py-12 twside-px-24">
          <Typography variant="P1" className="!twside-text-white">
            Gateway Health
          </Typography>
          <div>
            <PayuIcon
              type="cross"
              color="#ffffff"
              className="twside-cursor-pointer"
              onClick={() => setShow(false)}
            />
          </div>
        </div>
        <div className="twside-p-16">
          <Tabs
            tabs={TabsData}
            defaultTab={1}
            orientation="horizontal"
            onTabChange={handleTabChange}
          />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDowntime: () => {
      dispatch(downTimeListActions.fetchData());
    },
    fetchDowntimeFilter: () => {
      dispatch(downTimeFilterActions.fetchData());
    },
    updateFilter: (filters) => {
      dispatch(filterActions.updateDowntimeFilter(filters));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    downtimeList: downTimeListSelectors.getDowntimeList(state),
    downtimeListFetching: downTimeListSelectors.isFetching(state),
    downtimeListError: downTimeListSelectors.getErrorMsg(state),
    filters: filterSelectors.getFilters(state, nodes.downtimeList),
    downtimeFilter: downTimeFilterSelectors.getDowntimeFilter(state),
    downtimeFilterError: downTimeFilterSelectors.getErrorMsg(state),
    isdowntimeFilterFetching: downTimeFilterSelectors.isFetching(state),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Container);
